import React from 'react';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import Button from '../../../../../components/Button';
import { reDirectPage } from '../../../../../lib/common';
import { ORDER_RETURN_LIST_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import './OrderReturnDetailNavbar.scss';

const OrderReturnDetailNavbar = (props) => {
  const { onSubmit } = props;

  return (
    <FixedBottomNavBar className="order-return-detail-navbar">
      <div className="button-group">
        {/*반품 완료처리*/}
        <Button color="primary" text="반품 완료처리" onClick={() => onSubmit()} />

        {/*미리보기*/}
        <Button color="light" text="취소" onClick={() => reDirectPage({ path: ORDER_RETURN_LIST_URL_PATH })} />
      </div>
    </FixedBottomNavBar>
  );
};

export default OrderReturnDetailNavbar;
